import * as React from "react";

type Props = {
    isMenuVisible: boolean;
};

export function AccountFlyoutIcon(props: Props) {
    const visibleClass = props.isMenuVisible ? "arrow open" : "arrow";

    return (
        <div className="user-icon">
            <svg
                version="1.1"
                id="Ebene_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="24px"
                height="21px"
                viewBox="0 0 24 21"
                enableBackground="new 0 0 24 21"
                xmlSpace="preserve">
                <path
                    className="st0"
                    d="M24,12.2c0,3.4-1.4,6.5-3.7,8.6l-5.4-1.9v-2.6c1.6-1.2,2.6-3.3,2.6-5.5c0-3.6-2.5-6.5-5.5-6.5s-5.5,2.9-5.5,6.5c0,2.2,1,4.3,2.6,5.5v2.6l-5.4,1.9C1.4,18.6,0,15.6,0,12.2c0-6.6,5.4-12,12-12C18.6,0.2,24,5.6,24,12.2z"
                />
            </svg>
            <div className={visibleClass}></div>
        </div>
    );
}
